// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TGetUserDataModel, IMappers, TGetUserDataResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IPublicGetUserResponse } from '../../entities/UserDataModels/PublicGetUserResponse';

export function createGetUserDataModel(): TGetUserDataModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'users',
    pathApi: '/v1/get-user-data/',
    response: {
      '200': {
        contentType: 'json',
      },
    },
  };
}

export interface IGetUserDataOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
}

export async function fetchGetUserData<TResponse200>({
  httpApi,
  config,
  mappers,
}: IGetUserDataOptions<TResponse200>): Promise<FetchResponse<TGetUserDataResponse> | TResponse200> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetUserDataModel(),
    config,
  )) as FetchResponse<TGetUserDataResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicGetUserResponse, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetUserDataResponse>;
}
